import * as speechCommands from '@tensorflow-models/speech-commands'
import { vadDetector } from '../audio/vadDetector'

let recognizer

export const loadHumanVoiceModel = async () => {
    recognizer = speechCommands.create('BROWSER_FFT')
    await recognizer.ensureModelLoaded()
    console.log('TF model loaded')
    return recognizer
}

/**
 * Detects human voice by combining TF.js speech recognition results
 * with real-time Voice Activity Detection (VAD).
 */
export const detectHumanVoice = (scores) => {
    // 1. Check VAD state (High reliability for physical speech segments)
    const isVADActive = vadDetector.isSpeechDetected()

    // 2. Check TF.js model (High reliability for identifying speech vs noise)
    if (!recognizer || !scores) return { label: isVADActive ? 'human' : 'non-human', confidence: 0 }

    const labels = recognizer.wordLabels()
    let speechProbability = 0
    console.log(labels)
    scores.forEach((score, i) => {
        const label = labels[i]
        if (label !== '_background_noise_' && label !== '_unknown_') {
            speechProbability = Math.max(speechProbability, score)
        }
    })

    if (isVADActive && speechProbability > 0.45) {
        return { label: 'human', confidence: speechProbability }
    } else if (speechProbability > 0.7) {
        return { label: 'human', confidence: speechProbability }
    }
    
    return { label: 'non-human', confidence: speechProbability }
}
